module.exports = __webpack_public_path__ + "static/img/hide.48f3c504.png";